'use client'

import React, { useId, useLayoutEffect } from 'react'

export function SlideUpOnMount({
  children,
  className,
  style,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}) {
  const rawId = useId()
  const uniqueId = `slide-up-${rawId.replace(/:/g, '')}`

  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    window.scrollTo(0, 0)

    const el = document.getElementById(uniqueId)
    if (!el) return

    // Pushed-down starting position, with transitions disabled.
    const distanceToBottom = window.innerHeight - el.getBoundingClientRect().top
    el.style.transition = 'none'
    el.style.transform = `translateY(${distanceToBottom}px)`

    // Force the browser to commit the starting position so the change below
    // is seen as a transition between two distinct states (not coalesced).
    void el.offsetHeight

    // Animate up to the resting position.
    el.style.transition = 'transform 1100ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    el.style.transform = 'translateY(0px)'

    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto'
      }
    }
  }, [uniqueId])

  return (
    <div id={uniqueId} className={className} style={style} suppressHydrationWarning>
      {children}
    </div>
  )
}
